import React from "react";
import {
    XMarkIcon,
    InformationCircleIcon,
    PhoneIcon,
    EnvelopeIcon,
    BellIcon,
    NoSymbolIcon,
    TrashIcon,
    ChevronRightIcon,
    PhotoIcon
} from '@heroicons/react/24/solid';
import { useTranslation } from "react-i18next";

const UserInfoModal = ({ user, onClose }) => {
    const { t } = useTranslation('chat');
    if (!user) return null;

    const headerName = user?.chat_with?.name || `${user?.first_name} ${user?.last_name || ""}`;
    const headerImage = user?.chat_with?.image || "/img/icons/user-profile.png";
    const headerInitials = headerName?.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase();

    // Reusable Row Component
    const InfoRow = ({ icon: Icon, label, value, subtext, color = "text-gray-900" }) => (
        <div className="flex items-start px-6 py-4 bg-white hover:bg-gray-50 transition-colors cursor-pointer border-b border-gray-50 last:border-0">
            <Icon className="w-6 h-6 mr-5 text-gray-400 mt-0.5" />
            <div className="flex-1">
                <p className={`text-[15px] font-normal ${color}`}>{value || t('notProvided')}</p>
                <p className="text-xs text-gray-500 mt-1 uppercase tracking-tight font-medium">{label}</p>
                {subtext && <p className="text-xs text-gray-400 mt-1">{subtext}</p>}
            </div>
        </div>
    );

    return (
        <div className="flex flex-col h-full bg-white relative">

            {/* Header */}
            {/* <header className="flex items-center px-4 h-16 bg-white border-b border-gray-200 shrink-0">
                <button
                    onClick={onClose}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
                >
                    <XMarkIcon className="w-6 h-6" />
                </button>
                <h1 className="ml-4 text-lg font-medium text-gray-800">{t('profile')}</h1>
            </header> */}

            <div className="flex-1 overflow-y-auto">
                {/* Profile Hero Section */}
                <div className="bg-white pt-8 pb-6 px-4 flex flex-col items-center mb-3">
                    <div className="w-40 h-40 rounded-full bg-blue-100 overflow-hidden flex items-center justify-center mb-4 ring-4 ring-gray-50 shadow-inner">
                        {headerImage ? (
                            <img src={headerImage} className="w-full h-full object-cover" alt={headerName} />
                        ) : (
                            <span className="text-4xl font-bold text-blue-600">{headerInitials}</span>
                        )}
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-900">{headerName}</h2>
                    {/* <p className="text-gray-500 text-sm mt-1">{user?.phone || '+1 (555) 000-0000'}</p> */}
                </div>

                {/* <div className="bg-white shadow-sm mb-3">
                    <InfoRow icon={InformationCircleIcon} label={t('about')} value={user?.about || t('available')} />
                    <InfoRow icon={EnvelopeIcon} label={t('email')} value={user?.email || t('noEmail')} />
                </div>

                <div className="bg-white shadow-sm mb-3 px-6 py-4">
                    <div className="flex justify-between items-center mb-3">
                        <div className="flex items-center text-gray-500">
                            <PhotoIcon className="w-5 h-5 mr-2" />
                            <span className="text-sm font-medium uppercase tracking-wide">{t('mediaLinksDocs')}</span>
                        </div>
                        <div className="flex items-center text-blue-500 cursor-pointer hover:underline">
                            <span className="text-sm font-medium">12</span>
                            <ChevronRightIcon className="w-4 h-4 ml-1" />
                        </div>
                    </div>
                    <div className="flex gap-2">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="w-20 h-20 bg-gray-100 rounded-lg animate-pulse" />
                        ))}
                    </div>
                </div>

                <div className="bg-white shadow-sm mb-3">
                    <div className="flex items-center justify-between px-6 py-4 hover:bg-gray-50 cursor-pointer">
                        <div className="flex items-center">
                            <BellIcon className="w-6 h-6 mr-5 text-gray-400" />
                            <span className="text-[15px] text-gray-700">{t('muteNotifications')}</span>
                        </div>
                        <div className="w-10 h-5 bg-gray-200 rounded-full relative">
                            <div className="absolute left-1 top-1 bg-white w-3 h-3 rounded-full shadow-sm"></div>
                        </div>
                    </div>
                </div>

                <div className="bg-white shadow-sm mb-10">
                    <div className="flex items-center px-6 py-4 hover:bg-red-50 text-red-500 cursor-pointer transition-colors group">
                        <NoSymbolIcon className="w-6 h-6 mr-5 text-red-400 group-hover:text-red-500" />
                        <span className="text-[15px] font-medium">{t('blockUser', { userName: headerName })}</span>
                    </div>
                    <div className="flex items-center px-6 py-4 hover:bg-red-50 text-red-500 cursor-pointer transition-colors group">
                        <TrashIcon className="w-6 h-6 mr-5 text-red-400 group-hover:text-red-500" />
                        <span className="text-[15px] font-medium">{t('deleteChat')}</span>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default UserInfoModal;